import { title } from "framer-motion/client";
import {
  FaBullhorn,
  FaBalanceScale,
  FaLightbulb,
  FaBook,
  FaGlobeAfrica,
  FaBuilding,
  FaHeartbeat,
  FaUserShield,
  FaGlobe,
  FaHandshake,
  FaNewspaper,
  FaPeace,
  FaUserTie,
  FaProjectDiagram,
  FaGavel,
  FaChalkboardTeacher,
  FaChartLine,
  FaUsers,
  FaLightbulb as FaInnovation,
  FaCogs,
  FaCompass,
  FaLandmark,
} from "react-icons/fa";

const masterProgrammesData = [
  //  -------'''' The Normal Masters Programs '''''---------

  // Master of Arts in Global Business & Strategic Leadership
  {
    id: "leadership",
    title: "Master of Arts in Global Business & Strategic Leadership",
    brochurelink: "/documents/ESBD MA Brochure.pdf",
    topBgImage:
      "/image-fix/masterspage-imgs/business-people-chatting-in-office.jpg",

    topItems: [
      { title: "School", description: "Faculty of Business & Leadership" },
      { title: "Duration", description: "15 Months" },
      { title: "Type of Qualification", description: "Postgraduate Degree" },
      { title: "Format", description: "100% Online" },
      { title: "Postgraduate Credits", description: "90 ECTS (9 Modules)" },
      { title: "Level of Qualification", description: "MQF / EQF Level 7" },
      { title: "Intake 1", description: "March 2027 " },
      { title: "Intake 2", description: "September 2027" },
      { title: "Languages", description: "English" },
    ],

    // This holds the blab text
    blab: {
      // This is the blab text that will be displayed on the page
      start: "Transform your leadership journey with",

      // This is the finish text that will be displayed on the page
      finish:
        "Transform your leadership journey with ESBD's flagship postgraduate programme. Develop strategic thinking, global perspectives, and the skills to lead with confidence.",

      // This is the list of items that will be displayed below the blab text
      listBelowBlab: [
        "100% online MA within 12 months",
        "Licenced Higher Education in Malta, Europe by Malta Further & Higher Education Authority",
        "Accredited as a European higher education institution awarding university-level degrees",
        "Recognised internationally",
        "Specialist School in Diplomacy & Leadership Studies",
        "Career Focused Masters",
        "Affordable tuition",
        "€6000 total fees with option to pay in instalment",
        "European Summer School Programme",
        "Scholarships Available!",
        "Work Experience",
        "Study Tour",
      ],
    },

    // This is the overview text that will be displayed on the page
    overview: `The Master of Arts in Global Business & Strategic Leadership is a fully online MQF Level 7, 90 ECTS postgraduate programme designed for professionals who want to develop advanced capabilities in global business strategy, ethical leadership, organisational performance, and decision-making in complex environments.

The programme connects academic theory with practical application through case-based learning, scenario analysis, and real organisational challenges. It also includes live online lectures, webinars, and guest contributors with relevant professional expertise, giving learners direct exposure to current industry practice.
`,

    // Learning outcomes of the programme (preview structure: Competences, Knowledge, Skills)
    learningOutcomesStructured: {
      competences: [
        "Lead and influence diverse teams and organisations with ethical integrity, strategic foresight, and cross-cultural sensitivity in complex global environments.",
        "Exercise professional judgement in high-stakes business, governance, and policy contexts by integrating evidence, ethics, and long-term value considerations.",
        "Design and manage multi-stakeholder projects and strategic initiatives that drive organisational performance, innovation, and measurable impact across sectors.",
        "Initiate, implement, and evaluate strategic interventions with a high degree of autonomy, accountability, and responsibility for outcomes.",
        "Critically appraise and strengthen organisational systems, governance practices, and leadership structures through evidence-based diagnosis and improvement planning.",
        "Lead transformational change under uncertainty by applying emotionally intelligent, inclusive, and resilient leadership approaches in dynamic organisational settings.",
      ],
      knowledge: [
        "Critical and specialised understanding of global business strategy, strategic leadership theory, organisational development, and innovation management within international settings.",
        "Advanced knowledge of business ethics, corporate governance, strategic risk, and regulatory compliance, including implications for responsible leadership and accountability.",
        "In-depth analytical understanding of how geopolitical shifts, economic trends, digital disruption, and socio-cultural dynamics shape global markets and organisational strategy.",
        "Critical understanding of research paradigms and methodologies relevant to consultancy, business improvement, and strategic inquiry.",
        "Applied knowledge of EU, Maltese, and international regulatory contexts influencing strategy, leadership practice, financial accountability, and digital data protection.",
      ],
      skills: [
        "Analyse and synthesise complex organisational challenges using strategic frameworks and leadership diagnostics to generate practical and defensible recommendations.",
        "Design and justify business models, change strategies, and consulting interventions that demonstrate innovation, feasibility, and impact measurement.",
        "Communicate persuasively and professionally in academic and workplace contexts using advanced written, oral, and digital methods tailored to different stakeholder groups.",
        "Apply financial, data-driven, and digital tools to evaluate options, manage projects, and support evidence-based business decisions in global settings.",
        "Negotiate and manage stakeholder relationships through advanced interpersonal skills, cross-cultural awareness, and structured engagement planning.",
        "Produce postgraduate-quality outputs such as consultancy reports, strategic proposals, business cases, and policy briefs grounded in critical research and analysis.",
      ],
    },
    learningOutcomes: [],

    // The Modules Here is no londer valid because i created seperated components for them in the modules folder of the masters programs
    modules: {
      // Semester 1 - Foundation
      semester1: {
        title: "Foundation",
        courses: [
          {
            title: "Global Strategic Management",
            credits: 6,
            description:
              "The module helps you develop skills to create and implement business strategies for competitive global markets.",
          },
          {
            title: "Organisational Leadership",
            credits: 6,
            description:
              "This course teaches you about advanced leadership models and how to lead diverse teams while achieving organizational effectiveness.",
          },
          {
            title: "Business Ethics & Corporate Governance",
            credits: 6,
            description:
              "This course teaches you about ethical frameworks and sustainability practices and governance structures that exist in global business environments.",
          },
          {
            title: "Innovation and Entrepreneurship",
            credits: 6,
            description:
              "The module teaches students to detect innovative opportunities while creating business solutions for intricate business problems.",
          },
          {
            title: "Communication, Influence & Negotiation for Leaders",
            credits: 6,
            description:
              "The module teaches essential executive-level leadership skills through persuasive communication and influence and negotiation techniques.",
          },
        ],
      },

      // Semester 2 - Strategic Development
      semester2: {
        title: "Strategic Development",
        courses: [
          {
            title: "Strategic Marketing in Global Contexts",
            credits: 6,
            description:
              "TLearn to develop marketing campaigns for various international markets and cultural environments through this course",
          },
          {
            title: "Financial Decision-Making in Global Business",
            credits: 6,
            description:
              "Learn fundamental financial tools and analytical frameworks to support global investment and budgetary decision processes.",
          },
          {
            title: "Strategic Human Capital &amp; Talent Management",
            credits: 6,
            description:
              "Learn how to build successful plans for recruiting and developing and keeping top performers in demanding worldwide markets.",
          },
          {
            title: "Leading Change & Organisational Development",
            credits: 6,
            description:
              "TLead transformation efforts, manage resistance, and implement sustainable organisational change strategies.",
          },
          {
            title: "Research Methods for Strategic Leaders",
            credits: 6,
            description:
              "Acquire research design and data analysis competencies to solve strategic business problems.",
          },
        ],
      },

      // Semester 3 - Capstone & Dissertation
      semester3: {
        title: "Capstone & Dissertation",
        courses: [
          {
            title: "International Business &amp; Global Strategy",
            credits: 6,
            description:
              "The course teaches students to analyse globalization and market entry methods and cross-border strategic frameworks for international organization leadership.",
          },
          {
            title: "Professional Consulting in Practice",
            credits: 6,
            description:
              "The course teaches students how to apply consultancy methods and project scoping and client management approaches in real-world situations.",
          },
          {
            title: "Strategic Risk Management & Crisis Leadership",
            credits: 6,
            description:
              "The course teaches students to predict risks while leading under stress and handling crises through resilient and controlled responses.",
          },
          {
            title: "Master’s Thesis",
            credits: 12,
            description:
              "The module teaches students to detect innovative opportunities while creating business solutions for intricate business problems.",
          },
          {
            title: "Research Methods for Strategic Leaders",
            credits: 6,
            description:
              "You will complete an independent research project that explores a strategic leadership topic of your selection.",
          },
        ],
      },
    },

    // The Modules Here is no longer valid because i created seperated components for them in the rlrgibility requirements folder of the masters programs
    eligibilityRequirements: [
      // Under here we would have title then description

      // Direct Route
      {
        title: "Direct Route",
        description:
          "An accredited Bachelor’s degree (MQF Level 6 or equivalent) in any discipline from a recognised institution.",
      },

      // Postgraduate Diploma Route
      {
        title: "ESBD Route (Postgraduate Diploma Entry)",
        description: `Students who have finished the Postgraduate Diploma (60 ECTS credits), in Global
Business &amp; Strategic Leadership, at the European School of Business &amp; Diplomacy
(ESBD} can seamlessly advance to Semester 3 of the Masters program.

This route is ideal for those seeking staged progression or returning learners.
`,
      },

      // RPL Route
      {
        title: "RPL Route (Recognition of Prior Learning)",
        description: `We welcome applications from experienced professionals who do not hold a traditional degrees
but show evidence of:

~A minimum of 5 years of progressive work experience in leadership, management, or
relevant roles
~Evidence of professional development, certifications, or non-formal education aligned
with programme outcomes.
~A successful interview and/or portfolio review to determine suitability

This route values experiential learning and professional practice as a foundation for academic
progression.
`,
      },

      // English Language Requirements
      {
        title: "English Language Requirements",
        description: `The following qualifications meet our English language requirement:
- Native English speakers
- TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)
- Ielts (Minimum score: 5.5)
- Cambridge ESOL (CAE, Minimum score: C1)
- English as the language of instruction in formal education
- Equivalent qualifications you wish to be considered.`,
      },

      // Identity check
      {
        title: "Identity Check",
        description: `Applicants need to provide valid identification during the application process and they must
confirm their identity through a live Zoom meeting at the beginning of the course.`,
      },

      // IT Requirements
      {
        title: "IT Requirements",
        description: `Participants must have access to:
- Internet-enabled devices (computer, laptop, tablet)
- Speakers/headphones, webcam, and microphone
- Video-based teaching platforms and the course’s Virtual Learning Environment
(VLE)`,
      },
    ],

    // Fees Goes here
    fees: [
      {
        // we need to give the fees a value or something because if there stand alone fees is active it would fetch data from here
        title: "Registration fee",
        amount: 150,
      },
      {
        title: "Dissertation Fee",
        amount: 550,
      },
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "MA Global Business & Strategic Leadership",
        amount: 2400,
      },
    ],

    numberOfInstalments: 3, // This is the number of instalments for the payment plan

    // This ia a  bolean to triger the standalone qualification fees
    standaloneQualificationFees: true,

    standaloneQualificationFeesData: [
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "Semester 3 Entry (via EUSD)",
        amount: "2,400 + 550 dissertation fee",
      },
      {
        title: "Dissertation Only (if applicable)",
        amount: 550,
      },
    ],

    // Scholarships goes here - ( For the Programs that have it avaliable)
    scholarships: [
      // Emmanuel Addo Africa Scholarship
      {
        title: "Emmanuel Addo Africa Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 20,
        eligibility: [
          " Must be a citizen or permanent resident of an African country.",
          "	Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "	Must demonstrate leadership potential or community engagement in Africa.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Asia Scholarship
      {
        title: "Emmanuel Addo Asia Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 15,
        eligibility: [
          "	Must be a citizen or permanent resident of an Asian country.",
          "	Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "	Must demonstrate commitment to leadership or social impact.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Europe Scholarship
      {
        title: "Emmanuel Addo Europe Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 10,
        eligibility: [
          "Must be a citizen or permanent resident of a European country.",
          "Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "Must demonstrate strong leadership aspirations or civic involvement.",
          "Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Brilliant But Needy Scholarship
      {
        title: "Emmanuel Addo Brilliant But Needy Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 25,
        eligibility: [
          " Must demonstrate financial need.",
          " Must have earned at least a Second Class Upper (2:1) or Second Class Lower (2:2) honours degree.",
          " Must show evidence of academic excellence or potential.",
          " Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme",
        ],
      },

      // Emmanuel Addo Leadership Excellence Scholarship
      {
        title: "Emmanuel Addo Leadership Excellence Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 22,
        eligibility: [
          "	Must hold at least a Third Class honours degree or equivalent qualification.",
          "	Must have proven leadership experience in civil society, entrepreneurship, or public service.",
          "	Must provide a statement outlining leadership experience and impact.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },
    ],

    // Career Opportunities goes here
    careerOpportunities: [
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/address-svgrepo-com.svg",
        description: "Global Strategy Manager",
      },
      {
        // icon: <FaUserTie className="w-40 h-28 text-yellow-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/accelerate-svgrepo-com.svg",
        description: "International Business Development Manager",
      },
      {
        // icon: <FaLandmark className="w-40 h-28 text-white" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/business-svgrepo-com.svg",
        description: "Strategic Consultant",
      },
      {
        // icon: <FaGlobe className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/pie-chart-svgrepo-com.svg",
        description: "Head of Innovation or Transformation  ",
      },
      {
        // icon: <FaBuilding className="w-40 h-28 text-green-500" />,

        icon: "/image-fix/career-option-icons/business-duotone-pack/bank-svgrepo-com.svg",
        description: "Marketing Director – International Markets",
      },

      {
        // icon: <FaProjectDiagram className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/trophy-svgrepo-com.svg",
        description: "Chief Operating Officer (COO) – SMEs or Start-ups",
      },
      {
        // icon: <FaUserTie className="w-40 h-28 text-yellow-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/column-chart-svgrepo-com.svg",
        description: "Corporate Risk & Crisis Manager",
      },
      {
        // icon: <FaLandmark className="w-40 h-28 text-white" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/network-svgrepo-com.svg",
        description: "Leadership & Organisational Development Specialist",
      },
      {
        // icon: <FaGlobe className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/user-svgrepo-com.svg",
        description: "Political Affairs Advisor",
      },
      {
        // icon: <FaBuilding className="w-40 h-28 text-green-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/company-svgrepo-com.svg",
        description: "Public Sector Leadership & Policy Manager",
      },
    ],
  },

  // Master of Arts in Women’s & gender leadership studies
  {
    id: "womens-gender-leadership",
    title: "Master of Arts (MA) in Women’s & Gender Leadership Studies",
    topBgImage: "/image-fix/random-images/r23.jpg",
    topItems: [
      { title: "School", description: "Faculty of Business & Leadership" },
      { title: "Type of Qualification", description: "Masters" },
      {
        title: "Level of Qualification",
        description: "Level 7 (EQF/ MQF Level)",
      },
      { title: "Intake", description: "March 2027" },
      { title: "Duration", description: "1-3 years Full Time" },
      { title: "Format", description: "Online/Distance Learning" },
      { title: "Postgraduate Credits", description: "90 ECTS" },
      { title: "Languages", description: "English" },
    ],

    blab: {
      start: "Transform your leadership journey with",
      finish:
        "An accredited online MA, blending feminist theory, global gender studies, and advanced research for transformative advocacy and impactful careers worldwide.",
    },

    overview:
      "Embark on a transformative academic journey with our Master of Arts in Women’s & Gender Leadership Studies. This programme combines feminist theory, global gender dynamics, & advanced research methods to develop leaders capable of driving equality & justice.",
    modules: [
      { title: "Approaching Women’s Studies", credits: 3 },
      { title: "Gender & Development", credits: 3 },
      { title: "Gender & Migration", credits: 3 },
      { title: "Gender, Sexuality, & Law", credits: 3 },
      {
        title: "Introduction to Qualitative Methods & Data Analysis",
        credits: 3,
      },
      { title: "Feminist Research Methodologies", credits: 3 },
      { title: "Dissertation", credits: 12 },
    ],

    // Learning outcomes of the programme
    learningOutcomes: [
      `  Demonstrate advanced and specialized knowledge in business disciplines such as
strategic management, international marketing, financial decision-making,
organisational leadership, consulting, innovation, and risk governance at Level 7 of
the Malta Qualifications Framework (MQF).`,

      `  Apply critical knowledge to solve business problems and develop strategic solutions
and lead decision-making processes in various sectors and industries and cultural
environments.`,

      `  Strategic leadership competence in managing multicultural teams, driving
organisational transformation, and fostering sustainable innovation under conditions
of uncertainty and change.`,

      `  Executive-level presentation, negotiation, influence, and professional consultancy in
both physical and virtual leadership settings, as well as proficient communication and
collaboration skills.`,

      `  Professional ethics, reflective judgement, and responsible autonomy in business
practice, with a strong commitment to governance, stakeholder engagement, social
responsibility, and lifelong learning.`,

      `  Independent research capability to design and execute academic or practice-
based projects using appropriate qualitative and/or quantitative methods,
contributing to thought leadership and applied knowledge in global business and
strategic leadership.`,
    ],

    // Fees Goes here
    fees: [
      {
        // we need to give the fees a value or something because if there stand alone fees is active it would fetch data from here
        title: "Registration fee",
        amount: 150,
      },
      {
        title: "Dissertation Fee",
        amount: 550,
      },
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "MA Global Business & Strategic Leadership",
        amount: 2400,
      },
    ],

    // This ia a  bolean to triger the standalone qualification fees
    standaloneQualificationFees: false,
    careerOpportunities: [
      {
        icon: <FaBullhorn className="w-40 h-28 text-blue-500" />,
        description: "Advocacy",
      },
      {
        icon: <FaBalanceScale className="w-40 h-28 text-yellow-500" />,
        description: "Equality, Diversity & Inclusion",
      },
      {
        icon: <FaLightbulb className="w-40 h-28 text-white" />,
        description: "Gender Consultancy",
      },
      {
        icon: <FaBook className="w-40 h-28 text-blue-500" />,
        description: "Research & Teaching",
      },
      {
        icon: <FaGlobeAfrica className="w-40 h-28 text-green-500" />,
        description: "International & Humanitarian Work",
      },
      {
        icon: <FaBuilding className="w-40 h-28 text-red-500" />,
        description: "Politics",
      },
      {
        icon: <FaHeartbeat className="w-40 h-28 text-pink-500" />,
        description: "Reproductive & Sexual Health Services",
      },
    ],
  },

  // Master of Arts in Diplomacy &amp; International Relations
  {
    id: "diplomacy-international-relation",
    title: "Masters in International Relations, Politics, & Diplomacy",
    topBgImage: "/image-fix/random-images/r7.jpg",
    topItems: [
      {
        title: "School",
        description: "Faculty of International Relations, Politics & Diplomacy",
      },
      { title: "Type of Qualification", description: "Masters" },
      {
        title: "Level of Qualification",
        description: "Level 7 (EQF/ MQF Level)",
      },
      { title: "Intake", description: "March 2027" },
      { title: "Duration", description: "1-3 years Full Time" },
      { title: "Format", description: "Online/Distance Learning" },
      { title: "Postgraduate Credits", description: "90 ECTS" },
      { title: "Languages", description: "English" },
    ],

    blab: {
      start: "Prepare for leadership in global affairs with",
      finish:
        "Our MA in International Relations, Politics, & Diplomacy, combining advanced research, practical skills, and strategic expertise for impactful careers worldwide.",
    },

    overview:
      "The Master of Arts in International Relations, Politics, & Diplomacy is designed for future leaders & professionals in politics, diplomacy, & international relations. This programme combines advanced theoretical insights with practical applications, empowering students to navigate complex global challenges.",
    modules: {
      certificate: [
        { title: "Foundations of Politics", credits: 3 },
        { title: "Practical Politics in Africa", credits: 3 },
        { title: "Comparative Political Systems", credits: 3 },
        { title: "Cultural Relations & Diplomacy", credits: 3 },
        { title: "Introduction to International Relations", credits: 3 },
        { title: "Parliamentary Affairs", credits: 3 },
        {
          title: "Knowledge, Power, & Politics in Human Science",
          credits: 3,
        },
        {
          title: "Promoting Inclusivity & Sustainable Governance",
          credits: 3,
        },
      ],
      diploma: [
        { title: "Introduction to Diplomacy", credits: 2.5 },
        { title: "International Organisations", credits: 2.5 },
        { title: "Diplomatic Protocol & Practice", credits: 2.5 },
        { title: "Global Diplomatic Frameworks", credits: 2.5 },
        { title: "Foreign Policy Analysis & Implementation", credits: 2.5 },
        { title: "Principles of International Law", credits: 2.5 },
        { title: "Conflict Resolution & Mediation", credits: 2.5 },
        { title: "Modes of Diplomacy in the 21st Century", credits: 2.5 },
        { title: "Diplomatic Negotiation Techniques", credits: 2.5 },
        { title: "Trends & Transformations in World Politics", credits: 2.5 },
      ],
      masters: [
        { title: "Global Diplomatic Concepts & Models", credits: 5 },
        { title: "Economics, Politics, & Society in Africa", credits: 5 },
        { title: "Economics, Politics, & Society in Europe", credits: 5 },
        { title: "Advanced Research Methods in Diplomacy", credits: 5 },
        { title: "Dissertation", credits: 10 },
      ],
    },

    // Learning outcomes of the programme
    learningOutcomes: [
      `  Demonstrate advanced and specialized knowledge in business disciplines such as
strategic management, international marketing, financial decision-making,
organisational leadership, consulting, innovation, and risk governance at Level 7 of
the Malta Qualifications Framework (MQF).`,

      `  Apply critical knowledge to solve business problems and develop strategic solutions
and lead decision-making processes in various sectors and industries and cultural
environments.`,

      `  Strategic leadership competence in managing multicultural teams, driving
organisational transformation, and fostering sustainable innovation under conditions
of uncertainty and change.`,

      `  Executive-level presentation, negotiation, influence, and professional consultancy in
both physical and virtual leadership settings, as well as proficient communication and
collaboration skills.`,

      `  Professional ethics, reflective judgement, and responsible autonomy in business
practice, with a strong commitment to governance, stakeholder engagement, social
responsibility, and lifelong learning.`,

      `  Independent research capability to design and execute academic or practice-
based projects using appropriate qualitative and/or quantitative methods,
contributing to thought leadership and applied knowledge in global business and
strategic leadership.`,
    ],

    // Fees Goes here
    fees: [
      {
        // we need to give the fees a value or something because if there stand alone fees is active it would fetch data from here
        title: "Registration fee",
        amount: 150,
      },
      {
        title: "Dissertation Fee",
        amount: 550,
      },
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "MA Global Business & Strategic Leadership",
        amount: 2400,
      },
    ],

    // This ia a  bolean to triger the standalone qualification fees
    standaloneQualificationFees: false,

    careerOpportunities: [
      {
        icon: <FaUserShield className="w-40 h-28 text-purple-500" />,
        description: "Diplomatic Officer",
      },
      {
        icon: <FaGlobe className="w-40 h-28 text-blue-600" />,
        description: "Foreign Policy Analyst",
      },
      {
        icon: <FaHandshake className="w-40 h-28 text-yellow-600" />,
        description: "International Relations Consultant",
      },
      {
        icon: <FaNewspaper className="w-40 h-28 text-white" />,
        description: "Public Affairs Specialist",
      },
      {
        icon: <FaPeace className="w-40 h-28 text-green-500" />,
        description: "Conflict Resolution Specialist",
      },
      {
        icon: <FaUserTie className="w-40 h-28 text-gray-400" />,
        description: "Political Advisor",
      },
      {
        icon: <FaProjectDiagram className="w-40 h-28 text-blue-400" />,
        description: "Global Programme Manager",
      },
      {
        icon: <FaGavel className="w-40 h-28 text-red-400" />,
        description: "Politician",
      },
    ],
  },

  // Master of Arts in Executive Professional Consulting
  {
    id: "consulting",
    title: "Master of Arts in Executive Professional Consulting",
    topBgImage: "/image-fix/random-images/r9.jpeg",
    topItems: [
      { title: "School", description: "Faculty of Business & Leadership" },
      { title: "Type of Qualification", description: "Masters" },
      {
        title: "Level of Qualification",
        description: "Level 7 (EQF/ MQF Level)",
      },
      { title: "Intake", description: "March 2027" },
      { title: "Duration", description: "1-3 years Full Time" },
      { title: "Format", description: "Online/Distance Learning" },
      { title: "Postgraduate Credits", description: "90 ECTS" },
      { title: "Languages", description: "English" },
    ],

    blab: {
      start: "Empower your career with",
      finish:
        "Advanced consulting expertise, global strategies, and leadership skills for impactful roles in business and executive coaching.",
    },

    overview:
      "The Master of Arts in Executive Professional Consulting is a transformative programme tailored for aspiring consultants & leaders in global industries. This innovative course equips students with advanced expertise in consulting methodologies, strategic leadership, & global advisory practices.",

    // Learning outcomes of the programme
    learningOutcomes: [
      `  Demonstrate advanced and specialized knowledge in business disciplines such as
strategic management, international marketing, financial decision-making,
organisational leadership, consulting, innovation, and risk governance at Level 7 of
the Malta Qualifications Framework (MQF).`,

      `  Apply critical knowledge to solve business problems and develop strategic solutions
and lead decision-making processes in various sectors and industries and cultural
environments.`,

      `  Strategic leadership competence in managing multicultural teams, driving
organisational transformation, and fostering sustainable innovation under conditions
of uncertainty and change.`,

      `  Executive-level presentation, negotiation, influence, and professional consultancy in
both physical and virtual leadership settings, as well as proficient communication and
collaboration skills.`,

      `  Professional ethics, reflective judgement, and responsible autonomy in business
practice, with a strong commitment to governance, stakeholder engagement, social
responsibility, and lifelong learning.`,

      `  Independent research capability to design and execute academic or practice-
based projects using appropriate qualitative and/or quantitative methods,
contributing to thought leadership and applied knowledge in global business and
strategic leadership.`,
    ],

    modules: {
      pathways: {
        businessConsultant: [
          "Strategic Management",
          "Financial Analysis",
          "Marketing",
          "Global Business Consultancy",
        ],
        careerCoach: [
          "Career Coaching Principles",
          "Leadership Coaching",
          "Advanced Organisational Behaviour",
          "Ethics in Consulting",
        ],
      },
      masters: [
        {
          title: "Advanced Strategic Thinking & Problem Solving",
          credits: 5,
        },
        { title: "Leadership in Emerging Global Trends", credits: 5 },
        {
          title: "Ethics & Governance in Professional Consulting",
          credits: 5,
        },
        { title: "Advanced Global Consulting Strategies", credits: 5 },
        { title: "Capstone Professional Consulting Project", credits: 10 },
      ],
    },
    // Fees Goes here
    fees: [
      {
        // we need to give the fees a value or something because if there stand alone fees is active it would fetch data from here
        title: "Registration fee",
        amount: 150,
      },
      {
        title: "Dissertation Fee",
        amount: 550,
      },
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "MA Global Business & Strategic Leadership",
        amount: 2400,
      },
    ],

    // This ia a  bolean to triger the standalone qualification fees
    standaloneQualificationFees: true,
    careerOpportunities: [
      {
        icon: <FaChartLine className="w-40 h-28 text-blue-500" />,
        description: "Management Consultant",
      },
      {
        icon: <FaUsers className="w-40 h-28 text-yellow-500" />,
        description: "Executive Career Coach",
      },
      {
        icon: <FaProjectDiagram className="w-40 h-28 text-white" />,
        description: "Business Strategy Consultant",
      },
      {
        icon: <FaChalkboardTeacher className="w-40 h-28 text-blue-500" />,
        description: "Leadership & Development Specialist",
      },
      {
        icon: <FaBook className="w-40 h-28 text-green-500" />,
        description: "Corporate Training Consultant",
      },
      {
        icon: <FaCogs className="w-40 h-28 text-red-500" />,
        description: "Change Management Advisor",
      },
      {
        icon: <FaBuilding className="w-40 h-28 text-pink-500" />,
        description: "Organisational Development Consultant",
      },
      {
        icon: <FaInnovation className="w-40 h-28 text-purple-500" />,
        description: "Innovation Consultant",
      },
      {
        icon: <FaCompass className="w-40 h-28 text-sdorange" />,
        description: "Strategic Foresight Advisor",
      },
    ],
  },

  //  -------'''' The Postgraduate Masters Programs '''''---------

  // Postgraduate Certificate in Global Business & Strategic Leadership
  {
    id: "postgraduate-certificate-leadership",
    title: "Postgraduate Certificate in Global Business & Strategic Leadership",
    brochurelink: "/documents/ESBD MA Brochure.pdf",
    topBgImage: "/image-fix/random-images/r3.jpg",
    topItems: [
      { title: "School", description: "Faculty of Business & Leadership" },
      { title: "Type of Qualification", description: "Masters" },
      {
        title: "Level of Qualification",
        description: "Level 7 (EQF/ MQF Level)",
      },
      {
        title: "Intake 1",
        description: "March 2026",
      },
      { title: "Intake 2", description: "June 2026" },
      { title: "Duration", description: "1-3 years Full Time" },
      { title: "Format", description: "Online/Distance Learning" },
      { title: "Postgraduate Credits", description: "90 ECTS" },
      { title: "Languages", description: "English" },
    ],

    // This holds the blab text
    blab: {
      // This is the blab text that will be displayed on the page
      start: "Transform your leadership journey with",

      // This is the finish text that will be displayed on the page
      finish:
        "The Postgraduate Certificate in Global Business & Strategic Leadership program at our institution combines strategic foresight with emotional intelligence and global perspective to develop graduates who can lead executive management and governance and diplomatic roles effectively.",

      // This is the list of items that will be displayed below the blab text
      listBelowBlab: [
        "100% online MA within 12 months",
        "Licenced Higher Education in Malta, Europe by Malta Further & Higher Education Authority",
        "Accredited as a European higher education institution awarding university-level degrees",
        "Recognised internationally",
        "Specialist School in Diplomacy & Leadership Studies",
        "Career Focused Masters",
        "Affordable tuition",
        "€6000 total fees with option to pay in instalment",
        "European Summer School Programme",
        "Scholarships Available!",
        "Work Experience",
        "Study Tour",
      ],
    },

    // This is the overview text that will be displayed on the page
    overview: `The Postgraduate Certificate in Global Business & Strategic Leadership programme trains students to lead through strategic vision and global impact.

The 12-month MFHEA-accredited program targets motivated professionals who want to progress in business or diplomatic or political or organizational leadership roles. The program teaches students to develop strategic thinking abilities along with emotional intelligence and agile leadership competencies which help them handle complex situations and motivate teams while driving innovation.

The program combines academic excellence with practical application and personal growth to develop leaders who can lead with confidence and purpose in today's fast-changing global environment.
`,

    // Learning outcomes of the programme
    learningOutcomes: [
      `  Advanced and specialized knowledge in business disciplines such as
strategic management, international marketing, financial decision-making,
organisational leadership, consulting, innovation, and risk governance at Level 7 of
the Malta Qualifications Framework (MQF).`,

      `  Apply critical knowledge to solve business problems and develop strategic solutions
and lead decision-making processes in various sectors and industries and cultural
environments.`,

      `  Strategic leadership competence in managing multicultural teams, driving
organisational transformation, and fostering sustainable innovation under conditions
of uncertainty and change.`,

      `  Executive-level presentation, negotiation, influence, and professional consultancy in
both physical and virtual leadership settings, as well as proficient communication and
collaboration skills.`,

      `  Professional ethics, reflective judgement, and responsible autonomy in business
practice, with a strong commitment to governance, stakeholder engagement, social
responsibility, and lifelong learning.`,

      `  Independent research capability to design and execute academic or practice-
based projects using appropriate qualitative and/or quantitative methods,
contributing to thought leadership and applied knowledge in global business and
strategic leadership.`,
    ],

    // The Modules Here is no londer valid because i created seperated components for them in the modules folder of the masters programs
    modules: {
      // Semester 1 - Foundation
      semester1: {
        title: "Foundation",
        courses: [
          {
            title: "Global Strategic Management",
            credits: 6,
            description:
              "The module helps you develop skills to create and implement business strategies for competitive global markets.",
          },
          {
            title: "Organisational Leadership",
            credits: 6,
            description:
              "This course teaches you about advanced leadership models and how to lead diverse teams while achieving organizational effectiveness.",
          },
          {
            title: "Business Ethics & Corporate Governance",
            credits: 6,
            description:
              "This course teaches you about ethical frameworks and sustainability practices and governance structures that exist in global business environments.",
          },
          {
            title: "Innovation and Entrepreneurship",
            credits: 6,
            description:
              "The module teaches students to detect innovative opportunities while creating business solutions for intricate business problems.",
          },
          {
            title: "Communication, Influence & Negotiation for Leaders",
            credits: 6,
            description:
              "The module teaches essential executive-level leadership skills through persuasive communication and influence and negotiation techniques.",
          },
        ],
      },

      // Semester 2 - Strategic Development
      semester2: {
        title: "Strategic Development",
        courses: [
          {
            title: "Strategic Marketing in Global Contexts",
            credits: 6,
            description:
              "TLearn to develop marketing campaigns for various international markets and cultural environments through this course",
          },
          {
            title: "Financial Decision-Making in Global Business",
            credits: 6,
            description:
              "Learn fundamental financial tools and analytical frameworks to support global investment and budgetary decision processes.",
          },
          {
            title: "Strategic Human Capital &amp; Talent Management",
            credits: 6,
            description:
              "Learn how to build successful plans for recruiting and developing and keeping top performers in demanding worldwide markets.",
          },
          {
            title: "Leading Change & Organisational Development",
            credits: 6,
            description:
              "TLead transformation efforts, manage resistance, and implement sustainable organisational change strategies.",
          },
          {
            title: "Research Methods for Strategic Leaders",
            credits: 6,
            description:
              "Acquire research design and data analysis competencies to solve strategic business problems.",
          },
        ],
      },

      // Semester 3 - Capstone & Dissertation
      semester3: {
        title: "Capstone & Dissertation",
        courses: [
          {
            title: "International Business &amp; Global Strategy",
            credits: 6,
            description:
              "The course teaches students to analyse globalization and market entry methods and cross-border strategic frameworks for international organization leadership.",
          },
          {
            title: "Professional Consulting in Practice",
            credits: 6,
            description:
              "The course teaches students how to apply consultancy methods and project scoping and client management approaches in real-world situations.",
          },
          {
            title: "Strategic Risk Management & Crisis Leadership",
            credits: 6,
            description:
              "The course teaches students to predict risks while leading under stress and handling crises through resilient and controlled responses.",
          },
          {
            title: "Master’s Thesis",
            credits: 12,
            description:
              "The module teaches students to detect innovative opportunities while creating business solutions for intricate business problems.",
          },
          {
            title: "Research Methods for Strategic Leaders",
            credits: 6,
            description:
              "You will complete an independent research project that explores a strategic leadership topic of your selection.",
          },
        ],
      },
    },

    // The Modules Here is no longer valid because i created seperated components for them in the rlrgibility requirements folder of the masters programs
    eligibilityRequirements: [
      // Under here we would have title then description

      // Direct Route
      {
        title: "Direct Route",
        description:
          "An accredited Bachelor’s degree (MQF Level 6 or equivalent) in any discipline from a recognised institution.",
      },

      // Postgraduate Diploma Route
      {
        title: "ESBD Route (Postgraduate Diploma Entry)",
        description: `Students who have finished the Postgraduate Diploma (60 ECTS credits), in Global
Business &amp; Strategic Leadership, at the European School of Business &amp; Diplomacy
(ESBD} can seamlessly advance to Semester 3 of the Masters program.

This route is ideal for those seeking staged progression or returning learners.
`,
      },

      // RPL Route
      {
        title: "RPL Route (Recognition of Prior Learning)",
        description: `We welcome applications from experienced professionals who do not hold a traditional degrees
but show evidence of:

~A minimum of 5 years of progressive work experience in leadership, management, or
relevant roles
~Evidence of professional development, certifications, or non-formal education aligned
with programme outcomes.
~A successful interview and/or portfolio review to determine suitability

This route values experiential learning and professional practice as a foundation for academic
progression.
`,
      },

      // English Language Requirements
      {
        title: "English Language Requirements",
        description: `The following qualifications meet our English language requirement:
- Native English speakers
- TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)
- Ielts (Minimum score: 5.5)
- Cambridge ESOL (CAE, Minimum score: C1)
- English as the language of instruction in formal education
- Equivalent qualifications you wish to be considered.`,
      },

      // Identity check
      {
        title: "Identity Check",
        description: `Applicants need to provide valid identification during the application process and they must
confirm their identity through a live Zoom meeting at the beginning of the course.`,
      },

      // IT Requirements
      {
        title: "IT Requirements",
        description: `Participants must have access to:
- Internet-enabled devices (computer, laptop, tablet)
- Speakers/headphones, webcam, and microphone
- Video-based teaching platforms and the course’s Virtual Learning Environment
(VLE)`,
      },
    ],

    // Fees Goes here
    fees: [
      {
        // we need to give the fees a value or something because if there stand alone fees is active it would fetch data from here
        title: "Registration fee",
        amount: 150,
      },
      {
        title: "Dissertation Fee",
        amount: 550,
      },
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "MA Global Business & Strategic Leadership",
        amount: 2400,
      },
    ],

    numberOfInstalments: 3, // This is the number of instalments for the payment plan

    // This ia a  bolean to triger the standalone qualification fees
    standaloneQualificationFees: true,

    standaloneQualificationFeesData: [
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Dissertation Fee",
        amount: 1500,
      },
      {
        title: "Postgraduate Diploma",
        amount: "2,400 + 550 dissertation fee",
      },
      {
        title: "Dissertation Only (if applicable)",
        amount: 500,
      },
    ],

    // Scholarships goes here - ( For the Programs that have it avaliable)
    scholarships: [
      // Emmanuel Addo Africa Scholarship
      {
        title: "Emmanuel Addo Africa Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 20,
        eligibility: [
          " Must be a citizen or permanent resident of an African country.",
          "	Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "	Must demonstrate leadership potential or community engagement in Africa.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Asia Scholarship
      {
        title: "Emmanuel Addo Asia Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 15,
        eligibility: [
          "	Must be a citizen or permanent resident of an Asian country.",
          "	Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "	Must demonstrate commitment to leadership or social impact.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Europe Scholarship
      {
        title: "Emmanuel Addo Europe Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 10,
        eligibility: [
          "Must be a citizen or permanent resident of a European country.",
          "Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "Must demonstrate strong leadership aspirations or civic involvement.",
          "Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Brilliant But Needy Scholarship
      {
        title: "Emmanuel Addo Brilliant But Needy Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 25,
        eligibility: [
          " Must demonstrate financial need.",
          " Must have earned at least a Second Class Upper (2:1) or Second Class Lower (2:2) honours degree.",
          " Must show evidence of academic excellence or potential.",
          " Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme",
        ],
      },

      // Emmanuel Addo Leadership Excellence Scholarship
      {
        title: "Emmanuel Addo Leadership Excellence Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 22,
        eligibility: [
          "	Must hold at least a Third Class honours degree or equivalent qualification.",
          "	Must have proven leadership experience in civil society, entrepreneurship, or public service.",
          "	Must provide a statement outlining leadership experience and impact.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },
    ],

    // Career Opportunities goes here
    careerOpportunities: [
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/address-svgrepo-com.svg",
        description: "Global Strategy Manager",
      },
      {
        // icon: <FaUserTie className="w-40 h-28 text-yellow-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/accelerate-svgrepo-com.svg",
        description: "International Business Development Manager",
      },
      {
        // icon: <FaLandmark className="w-40 h-28 text-white" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/business-svgrepo-com.svg",
        description: "Strategic Consultant",
      },
      {
        // icon: <FaGlobe className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/pie-chart-svgrepo-com.svg",
        description: "Head of Innovation or Transformation  ",
      },
      {
        // icon: <FaBuilding className="w-40 h-28 text-green-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/bank-svgrepo-com.svg",
        description: "Marketing Director – International Markets",
      },

      {
        // icon: <FaProjectDiagram className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/trophy-svgrepo-com.svg",
        description: "Chief Operating Officer (COO) – SMEs or Start-ups",
      },
      {
        // icon: <FaUserTie className="w-40 h-28 text-yellow-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/column-chart-svgrepo-com.svg",
        description: "Corporate Risk & Crisis Manager",
      },
      {
        // icon: <FaLandmark className="w-40 h-28 text-white" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/network-svgrepo-com.svg",
        description: "Leadership & Organisational Development Specialist",
      },
      {
        // icon: <FaGlobe className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/user-svgrepo-com.svg",
        description: "Political Affairs Advisor",
      },
      {
        // icon: <FaBuilding className="w-40 h-28 text-green-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/company-svgrepo-com.svg",
        description: "Public Sector Leadership & Policy Manager",
      },
    ],
  },

  //  -------'''' The Undergraduate Masters Programs '''''---------

  // Postgraduate Diploma in Global Business & Strategic Leadership
  {
    id: "postgraduate-diploma-leadership",
    title: "Postgraduate Diploma in Global Business & Strategic Leadership",
    brochurelink: "/documents/ESBD MA Brochure.pdf",
    topBgImage: "/image-fix/random-images/r2.jpg",
    topItems: [
      { title: "School", description: "Faculty of Business & Leadership" },
      { title: "Type of Qualification", description: "Masters" },
      {
        title: "Level of Qualification",
        description: "Level 7 (EQF/ MQF Level)",
      },
      {
        title: "Intake 1",
        description: "March 2026",
      },
      { title: "Intake 2", description: "June 2026" },
      { title: "Duration", description: "1-3 years Full Time" },
      { title: "Format", description: "Online/Distance Learning" },
      { title: "Postgraduate Credits", description: "90 ECTS" },
      { title: "Languages", description: "English" },
    ],

    // This holds the blab text
    blab: {
      // This is the blab text that will be displayed on the page
      start: "Transform your leadership journey with",

      // This is the finish text that will be displayed on the page
      finish:
        "The Postgraduate Diploma in Global Business & Strategic Leadership program at our institution combines strategic foresight with emotional intelligence and global perspective to develop graduates who can lead executive management and governance and diplomatic roles effectively.",

      // This is the list of items that will be displayed below the blab text
      listBelowBlab: [
        "100% online MA within 12 months",
        "Licenced Higher Education in Malta, Europe by Malta Further & Higher Education Authority",
        "Accredited as a European higher education institution awarding university-level degrees",
        "Recognised internationally",
        "Specialist School in Diplomacy & Leadership Studies",
        "Career Focused Masters",
        "Affordable tuition",
        "€6000 total fees with option to pay in instalment",
        "European Summer School Programme",
        "Scholarships Available!",
        "Work Experience",
        "Study Tour",
      ],
    },

    // This is the overview text that will be displayed on the page
    overview: `The Postgraduate Diploma in Global Business & Strategic Leadership programme trains students to lead through strategic vision and global impact.

The 12-month MFHEA-accredited program targets motivated professionals who want to progress in business or diplomatic or political or organizational leadership roles. The program teaches students to develop strategic thinking abilities along with emotional intelligence and agile leadership competencies which help them handle complex situations and motivate teams while driving innovation.

The program combines academic excellence with practical application and personal growth to develop leaders who can lead with confidence and purpose in today's fast-changing global environment.
`,

    // Learning outcomes of the programme
    learningOutcomes: [
      `  Advanced and specialized knowledge in business disciplines such as
strategic management, international marketing, financial decision-making,
organisational leadership, consulting, innovation, and risk governance at Level 7 of
the Malta Qualifications Framework (MQF).`,

      `  Apply critical knowledge to solve business problems and develop strategic solutions
and lead decision-making processes in various sectors and industries and cultural
environments.`,

      `  Strategic leadership competence in managing multicultural teams, driving
organisational transformation, and fostering sustainable innovation under conditions
of uncertainty and change.`,

      `  Executive-level presentation, negotiation, influence, and professional consultancy in
both physical and virtual leadership settings, as well as proficient communication and
collaboration skills.`,

      `  Professional ethics, reflective judgement, and responsible autonomy in business
practice, with a strong commitment to governance, stakeholder engagement, social
responsibility, and lifelong learning.`,

      `  Independent research capability to design and execute academic or practice-
based projects using appropriate qualitative and/or quantitative methods,
contributing to thought leadership and applied knowledge in global business and
strategic leadership.`,
    ],

    // The Modules Here is no londer valid because i created seperated components for them in the modules folder of the masters programs
    modules: {
      // Semester 1 - Foundation
      semester1: {
        title: "Foundation",
        courses: [
          {
            title: "Global Strategic Management",
            credits: 6,
            description:
              "The module helps you develop skills to create and implement business strategies for competitive global markets.",
          },
          {
            title: "Organisational Leadership",
            credits: 6,
            description:
              "This course teaches you about advanced leadership models and how to lead diverse teams while achieving organizational effectiveness.",
          },
          {
            title: "Business Ethics & Corporate Governance",
            credits: 6,
            description:
              "This course teaches you about ethical frameworks and sustainability practices and governance structures that exist in global business environments.",
          },
          {
            title: "Innovation and Entrepreneurship",
            credits: 6,
            description:
              "The module teaches students to detect innovative opportunities while creating business solutions for intricate business problems.",
          },
          {
            title: "Communication, Influence & Negotiation for Leaders",
            credits: 6,
            description:
              "The module teaches essential executive-level leadership skills through persuasive communication and influence and negotiation techniques.",
          },
        ],
      },

      // Semester 2 - Strategic Development
      semester2: {
        title: "Strategic Development",
        courses: [
          {
            title: "Strategic Marketing in Global Contexts",
            credits: 6,
            description:
              "TLearn to develop marketing campaigns for various international markets and cultural environments through this course",
          },
          {
            title: "Financial Decision-Making in Global Business",
            credits: 6,
            description:
              "Learn fundamental financial tools and analytical frameworks to support global investment and budgetary decision processes.",
          },
          {
            title: "Strategic Human Capital &amp; Talent Management",
            credits: 6,
            description:
              "Learn how to build successful plans for recruiting and developing and keeping top performers in demanding worldwide markets.",
          },
          {
            title: "Leading Change & Organisational Development",
            credits: 6,
            description:
              "TLead transformation efforts, manage resistance, and implement sustainable organisational change strategies.",
          },
          {
            title: "Research Methods for Strategic Leaders",
            credits: 6,
            description:
              "Acquire research design and data analysis competencies to solve strategic business problems.",
          },
        ],
      },

      // Semester 3 - Capstone & Dissertation
      semester3: {
        title: "Capstone & Dissertation",
        courses: [
          {
            title: "International Business &amp; Global Strategy",
            credits: 6,
            description:
              "The course teaches students to analyse globalization and market entry methods and cross-border strategic frameworks for international organization leadership.",
          },
          {
            title: "Professional Consulting in Practice",
            credits: 6,
            description:
              "The course teaches students how to apply consultancy methods and project scoping and client management approaches in real-world situations.",
          },
          {
            title: "Strategic Risk Management & Crisis Leadership",
            credits: 6,
            description:
              "The course teaches students to predict risks while leading under stress and handling crises through resilient and controlled responses.",
          },
          {
            title: "Master’s Thesis",
            credits: 12,
            description:
              "The module teaches students to detect innovative opportunities while creating business solutions for intricate business problems.",
          },
          {
            title: "Research Methods for Strategic Leaders",
            credits: 6,
            description:
              "You will complete an independent research project that explores a strategic leadership topic of your selection.",
          },
        ],
      },
    },

    // The Modules Here is no longer valid because i created seperated components for them in the rlrgibility requirements folder of the masters programs
    eligibilityRequirements: [
      // Under here we would have title then description

      // Direct Route
      {
        title: "Direct Route",
        description:
          "An accredited Bachelor’s degree (MQF Level 6 or equivalent) in any discipline from a recognised institution.",
      },

      // Postgraduate Diploma Route
      {
        title: "ESBD Route (Postgraduate Diploma Entry)",
        description: `Students who have finished the Postgraduate Diploma (60 ECTS credits), in Global
Business &amp; Strategic Leadership, at the European School of Business &amp; Diplomacy
(ESBD} can seamlessly advance to Semester 3 of the Masters program.

This route is ideal for those seeking staged progression or returning learners.
`,
      },

      // RPL Route
      {
        title: "RPL Route (Recognition of Prior Learning)",
        description: `We welcome applications from experienced professionals who do not hold a traditional degrees
but show evidence of:

~A minimum of 5 years of progressive work experience in leadership, management, or
relevant roles
~Evidence of professional development, certifications, or non-formal education aligned
with programme outcomes.
~A successful interview and/or portfolio review to determine suitability

This route values experiential learning and professional practice as a foundation for academic
progression.
`,
      },

      // English Language Requirements
      {
        title: "English Language Requirements",
        description: `The following qualifications meet our English language requirement:
- Native English speakers
- TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)
- Ielts (Minimum score: 5.5)
- Cambridge ESOL (CAE, Minimum score: C1)
- English as the language of instruction in formal education
- Equivalent qualifications you wish to be considered.`,
      },

      // Identity check
      {
        title: "Identity Check",
        description: `Applicants need to provide valid identification during the application process and they must
confirm their identity through a live Zoom meeting at the beginning of the course.`,
      },

      // IT Requirements
      {
        title: "IT Requirements",
        description: `Participants must have access to:
- Internet-enabled devices (computer, laptop, tablet)
- Speakers/headphones, webcam, and microphone
- Video-based teaching platforms and the course’s Virtual Learning Environment
(VLE)`,
      },
    ],

    // Fees Goes here
    fees: [
      {
        // we need to give the fees a value or something because if there stand alone fees is active it would fetch data from here
        title: "Registration fee",
        amount: 150,
      },
      {
        title: "Dissertation Fee",
        amount: 550,
      },
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "MA Global Business & Strategic Leadership",
        amount: 2400,
      },
    ],

    numberOfInstalments: 3, // This is the number of instalments for the payment plan

    // This ia a  bolean to triger the standalone qualification fees
    standaloneQualificationFees: true,

    standaloneQualificationFeesData: [
      {
        title: "Postgraduate Certificate",
        amount: 1400,
      },
      {
        title: "Postgraduate Diploma",
        amount: 1500,
      },
      {
        title: "Semester 3 Entry (via EUSD)",
        amount: "2,400 + 550 dissertation fee",
      },
      {
        title: "Dissertation Only (if applicable)",
        amount: 550,
      },
    ],

    // Scholarships goes here - ( For the Programs that have it avaliable)
    scholarships: [
      // Emmanuel Addo Africa Scholarship
      {
        title: "Emmanuel Addo Africa Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 20,
        eligibility: [
          " Must be a citizen or permanent resident of an African country.",
          "	Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "	Must demonstrate leadership potential or community engagement in Africa.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Asia Scholarship
      {
        title: "Emmanuel Addo Asia Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 15,
        eligibility: [
          "	Must be a citizen or permanent resident of an Asian country.",
          "	Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "	Must demonstrate commitment to leadership or social impact.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Europe Scholarship
      {
        title: "Emmanuel Addo Europe Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 10,
        eligibility: [
          "Must be a citizen or permanent resident of a European country.",
          "Must hold a recognised Bachelor’s degree or equivalent qualification.",
          "Must demonstrate strong leadership aspirations or civic involvement.",
          "Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },

      // Emmanuel Addo Brilliant But Needy Scholarship
      {
        title: "Emmanuel Addo Brilliant But Needy Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 25,
        eligibility: [
          " Must demonstrate financial need.",
          " Must have earned at least a Second Class Upper (2:1) or Second Class Lower (2:2) honours degree.",
          " Must show evidence of academic excellence or potential.",
          " Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme",
        ],
      },

      // Emmanuel Addo Leadership Excellence Scholarship
      {
        title: "Emmanuel Addo Leadership Excellence Scholarship",
        status: "APPLICATION OPEN",
        program: "Masters",
        school: "Master of Arts in Global Business & Strategic Leadership",
        value: 22,
        eligibility: [
          "	Must hold at least a Third Class honours degree or equivalent qualification.",
          "	Must have proven leadership experience in civil society, entrepreneurship, or public service.",
          "	Must provide a statement outlining leadership experience and impact.",
          "	Must have submitted a complete application for the Master of Arts in Global Business & Strategic Leadership programme.",
        ],
      },
    ],

    // Career Opportunities goes here
    careerOpportunities: [
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/address-svgrepo-com.svg",
        description: "Global Strategy Manager",
      },
      {
        // icon: <FaUserTie className="w-40 h-28 text-yellow-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/accelerate-svgrepo-com.svg",
        description: "International Business Development Manager",
      },
      {
        // icon: <FaLandmark className="w-40 h-28 text-white" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/business-svgrepo-com.svg",
        description: "Strategic Consultant",
      },
      {
        // icon: <FaGlobe className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/pie-chart-svgrepo-com.svg",
        description: "Head of Innovation or Transformation  ",
      },
      {
        // icon: <FaBuilding className="w-40 h-28 text-green-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/bank-svgrepo-com.svg",
        description: "Marketing Director – International Markets",
      },

      {
        // icon: <FaProjectDiagram className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/trophy-svgrepo-com.svg",
        description: "Chief Operating Officer (COO) – SMEs or Start-ups",
      },
      {
        // icon: <FaUserTie className="w-40 h-28 text-yellow-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/column-chart-svgrepo-com.svg",
        description: "Corporate Risk & Crisis Manager",
      },
      {
        // icon: <FaLandmark className="w-40 h-28 text-white" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/network-svgrepo-com.svg",
        description: "Leadership & Organisational Development Specialist",
      },
      {
        // icon: <FaGlobe className="w-40 h-28 text-blue-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/user-svgrepo-com.svg",
        description: "Political Affairs Advisor",
      },
      {
        // icon: <FaBuilding className="w-40 h-28 text-green-500" />,
        icon: "/image-fix/career-option-icons/business-duotone-pack/company-svgrepo-com.svg",
        description: "Public Sector Leadership & Policy Manager",
      },
    ],
  },
];

export default masterProgrammesData;

// commit save 2
// commit save 3
